export const exportLabels = {
  menu_button: 'Export data',
  menu_excel: 'Excel workbook (all data)',
  menu_csv: 'CSV files…',
  downloading: 'Preparing the file…',
  downloaded: 'Export downloaded',

  csv_title: 'Export data as CSV',
  csv_intro:
    'Choose the tables to download. One table gives a CSV file, several give a ZIP of CSV files (UTF-8, comma separated, dot decimals, ISO dates).',
  csv_loading: 'Loading the available tables…',
  csv_load_error: 'Could not load the available tables. Close the dialog and retry.',
  csv_select_all: 'Select all',
  csv_clear: 'Clear',
  csv_download: (count: number) => (count > 1 ? `Download ${count} files (ZIP)` : count === 1 ? 'Download CSV' : 'Download'),
  csv_cancel: 'Cancel',
  rows: (count: number) => `${count.toLocaleString('en-US')} ${count === 1 ? 'row' : 'rows'}`,
  not_exported: {
    stale: 'Out of date: re-run the analysis to export it',
    missing: 'No result yet: run the analysis to export it',
  },

  error_no_up_to_date_results: 'No up-to-date results to export. Run at least one analysis, then retry.',
  error_busy: 'The export service is busy. Please retry later.',
  error_busy_retry_after: (seconds: number) => `The export service is busy. Please retry in ${seconds} s.`,
  error_too_large: 'A table is too large for an Excel sheet: export it as CSV instead.',
  error_invalid_request: 'The export request was rejected. Reload the table list and retry.',
  error_not_found: 'This project was not found, or you do not have access to it.',
  error_failed: 'The export could not be generated. Please retry; contact support if the problem persists.',
  error_unknown: 'An unexpected error occurred while exporting the data.',
} as const;
